/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { SpaceObjectType } from '@ootk/src/main';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
import { UranusRings } from './uranus-rings';
export var UranusTextureQuality;
(function (UranusTextureQuality) {
    UranusTextureQuality["POTATO"] = "512";
    UranusTextureQuality["ULTRA"] = "2k";
})(UranusTextureQuality || (UranusTextureQuality = {}));
export class Uranus extends CelestialBody {
    radius = 24622;
    RADIUS = this.radius;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    orbitalPeriod = 84 * 365.25 * 24 * 3600;
    meanDistanceToSun = 2870658186;
    eci;
    type = SpaceObjectType.ICE_GIANT;
    rings_;
    color = PlanetColors.URANUS;
    textureQuality = UranusTextureQuality.POTATO;
    constructor() {
        super();
        this.rings_ = new UranusRings(this);
    }
    async init(gl) {
        await super.init(gl);
        await this.rings_.init(gl);
    }
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/uranus${this.textureQuality}.jpg`;
    }
    useHighestQualityTexture() {
        this.textureQuality = UranusTextureQuality.ULTRA;
        this.loadTexture();
    }
    getName() {
        return SolarBody.Uranus;
    }
    update(simTime) {
        super.update(simTime);
        this.rings_.update(simTime);
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
        this.rings_.draw(sunPosition, tgtBuffer);
    }
}
